import { render, staticRenderFns } from "./documentos.vue?vue&type=template&id=79ae16b2&scoped=true&"
import script from "./documentos.vue?vue&type=script&lang=js&"
export * from "./documentos.vue?vue&type=script&lang=js&"
import style0 from "./documentos.vue?vue&type=style&index=0&id=79ae16b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ae16b2",
  null
  
)

export default component.exports